import axiosInstance from "../axiosInstance";
import { ApiResponse } from "@/types/apiResponse";
import { CreateContactQueryRequest, ContactQuery } from "@/types/contactQueries";

export const createContactQuery = async (
  payload: CreateContactQueryRequest
): Promise<ApiResponse<ContactQuery>> => {
  const response = await axiosInstance.post("/contact-queries", payload);
  return response.data;
};
